import { render, staticRenderFns } from "./ImageZoomBlock.vue?vue&type=template&id=4fb9deb7&scoped=true&"
import script from "./ImageZoomBlock.vue?vue&type=script&lang=js&"
export * from "./ImageZoomBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/ImageZoomBlock.scss?vue&type=style&index=0&id=4fb9deb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9deb7",
  null
  
)

export default component.exports